/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { object, string } from 'prop-types';

// MUI
import {
    Grid,
    Divider,
} from '@material-ui/core';

// SVGs
import shareIcon from '../../Assets/shareIcon.svg';
import RecipientBookBrandColorIcons from '../../Helpers/RecipientBookBrandColorIcons';

// Helpers
import { anniversaryReminderGroup, occasionsMapping, maskPhoneNumber } from '../../Helpers/Helpers';
import { RecipientBookContext } from '../../Context/RecipientBookContext';
// import { additionalOccasionsList, anniversaryReminderGroup, occasionsMapping } from '../../Helpers/Helpers';
import { getFeatureFlag } from '../../../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';

// Components
import AddOccasionsForm from './AddOccasionsForm';
import AdditionalOccasions from './AdditionalOccasions';
import { Delete } from '@material-ui/icons';

const AddOccasions = ({ classes, parentComponent, rcpFirstName, rcpLastName }) => {
    const { recipientState } = useContext(RecipientBookContext);
    const [switchStatus, setSwitchStatus] = useState();
    const isShareLinkEnabled = useSelector(getFeatureFlag('is-recipient-book-share-link-enabled'));
    const isShowingReminderPreferences = useSelector(getFeatureFlag('sms-reminder-notification-preferences'));

    const methods = useFormContext({ mode: 'all' });
    const {
        watch, setValue, getValues
    } = methods;
    const isHolidayOccasion = (occ) => (Number(occ?.occasion) >= 5 && Number(occ?.occasion) <= 21);
    const relationship = watch('relationship');
    const getOccasionValuesFromRHF = getValues('occasions');

    const getStatusOfSwitch = (switchStatus, index) => {
        methods.setValue(`occasions[${index}].subscribedEmail`, switchStatus);
        setSwitchStatus(switchStatus);
        if (switchStatus === false) {
            methods.setValue(`occasions[${index}].subscribedPhone`, switchStatus);
        };
    };

    useEffect(() => {
        const anniversaryOccasion = getOccasionValuesFromRHF.some((occ) => (occ.occasion === '1'));
        const reminderPhone = maskPhoneNumber(recipientState?.addressBookResponse?.reminderPhone || '');
        // Check for relationship value and if occasion already exists in RHF state
        if (anniversaryReminderGroup.includes(relationship) && !anniversaryOccasion) {
            setValue('occasions', [...getOccasionValuesFromRHF, {
                occasion: '1', desc: 'Anniversary', dateDD: '', dateMM: '', dateYYYY: '', subscribedEmail: true, subscribedPhone: false, reminderPhone, reminderEmail: '', subscribed: true,
            },
            ]);
        } else if (relationship && !anniversaryReminderGroup.includes(relationship) && anniversaryOccasion) {
            setValue('occasions', [...getOccasionValuesFromRHF.filter((item) => item.occasion !== '1')]);
        }
    }, [relationship]);

    const handleDeleteOccasion = (index) => {
        const updatedOccasions = getOccasionValuesFromRHF.filter((_, i) => i !== index);
        setValue('occasions', updatedOccasions);
    };

    return (
        <div className={classes.container}>
            {isShowingReminderPreferences && <Grid item xs={12}>
                <div>
                    <p className={classes.sectionTitle}>Reminders</p>
                    <p className={classes.sectionInfo}>Receive timely reminder notifications sent seamlessly to your email. Want reminders sent by text? <Link to="/account/email-preference" style={{ color: '#1F6BC6' }}>Tap here.</Link></p>
                </div>
            </Grid>}
            <Divider className={classes.dividerStyle} />
            {getOccasionValuesFromRHF.map((occasion, i) => (
                <Grid container justifyContent="space-between" alignItems="center" key={occasion.occasionId}>
                    <div className={classes.occDiv}>
                        <Grid container item className={classes.occasion}>
                            <RecipientBookBrandColorIcons className={classes.iconStyle} icon={occasionsMapping?.[occasion?.occasion]?.name} strockClass={classes.iconStyleStroke} />
                            <span className={classes.occasion}>{occasion?.desc}</span>
                        </Grid>
                        {occasion.occasion !== '2' && (
                            <Delete
                                className={classes.iconStyle}
                                onClick={() => handleDeleteOccasion(i)}
                                style={{ cursor: 'pointer' }}
                            />
                        )}
                    </div>
                    {isShareLinkEnabled
                        && (
                            <Grid item>
                                <Grid container>
                                    <img src={shareIcon} alt="share icon" />
                                    <button type="button" className={classes.shareBtn}>Share Link</button>
                                </Grid>
                            </Grid>
                        )}
                    <AddOccasionsForm switchStatus={switchStatus} key={occasion?.occasion} classes={classes} showDivider occasion={occasion} index={i} methods={methods} holidayOccasion={isHolidayOccasion(occasion)} parentComponent={parentComponent} rcpFirstName={rcpFirstName} rcpLastName={rcpLastName} getStatusOfSwitch={getStatusOfSwitch} />
                </Grid>
            ))}
            <AdditionalOccasions classes={classes} methods={methods} occasions={getOccasionValuesFromRHF} parentComponent={parentComponent} />
        </div>
    );
};

AddOccasions.propTypes = {
    rcpLastName: string,
    rcpFirstName: string,
    classes: object.isRequired,
    parentComponent: string.isRequired,
};

export default AddOccasions;